import { Component } from '@angular/core';

@Component({
  selector: 'app-value-prop',
  standalone: true,
  templateUrl: './value-prop.component.html',
  styleUrl: './value-prop.component.scss'
})
export class ValuePropComponent {}

